import { ApiFragmentNode } from "../shared/interfaces";
import React from "react";

const styles = {
    imgStyle: {
        maxWidth: "100%",
        maxHeight: "120px",
        objectFit: "contain" as const, // Show full image
        display: "block",
        borderRadius: "8px",
        margin: "0 auto", // Center horizontally
        backgroundColor: "#f5f5f5", // Light background to show image bounds
    },
    containerStyle: {
        height: "120px",
        width: "100%",
        maxWidth: "100%",
        display: "flex",
        alignItems: "center", // Center vertically
        justifyContent: "center", // Center horizontally
    },
};

export default function FragmentNodePreviewImage({ node }: { node: ApiFragmentNode }) {
    return (
        <div style={styles.containerStyle}>
            <img
                style={styles.imgStyle}
                src={`/api/fragmentNodeImage/${node.id}`}
                alt={node.title}
            />
        </div>
    );
}
